import Card from '../../components/Card'
import { IssuedCertificatesActions, IssuedCertificatesTable } from './IssuedCertificates'
import useIssuedCertificates from './useIssuedCertificates'
import { strings as S } from './strings'

/**
 * طباعة الشهادات inside the programme report — the legacy report's last tab: the same
 * roster and downloads as `/print-certificate`, for the programme and the dates the report
 * is already showing.
 *
 * @param {{ value: string, label: string }} program
 */
export default function ProgramCertificatesCard({ program, fromDate, toDate }) {
  const certificates = useIssuedCertificates({ programId: program.value, program, fromDate, toDate })

  return (
    <Card title={S.title} actions={<IssuedCertificatesActions certificates={certificates} />}>
      <IssuedCertificatesTable certificates={certificates} resetKey={`${program.value}|${fromDate}|${toDate}`} />
    </Card>
  )
}
